import { _, allRoles, isAuthorized, lazyLoadView } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'
import { legacyRoutes } from '@/ui-kit/routes/UiKitLegacy.routes'
import { ndsRoutes } from '@/ui-kit/routes/UiKitNds.routes'
import { pluginsRoutes } from '@/ui-kit/routes/UiKitPlugins.routes'
import { sharedComponentsRoutes } from '@/ui-kit/routes/UiKitSharedComponents.routes'
import { composablesRoutes } from '@/ui-kit/routes/UiKitComposables.routes'

export const uiKitRoutes: RouteConfig = {
  path: '/ui-kit',
  component: () => lazyLoadView(import('@/ui-kit/UiKitView.vue')),
  meta: {
    title: _('UI kit'),
    icon: 'toolbox',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: allRoles,
  },
  children: [
    {
      path: '',
      name: 'ui-kit',
      component: () => lazyLoadView(import('@/ui-kit/UiKitHomeView.vue')),
      meta: {
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: allRoles,
        doc_id: 'home',
      },
    },
    {
      path: 'ui-nds-overview',
      name: 'ui-nds-overview',
      component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsOverviewView.vue')),
      meta: {
        title: 'NDS Overview',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: allRoles,
        doc_id: 'ui-nds-overview',
      },
    },
    ...legacyRoutes,
    ...ndsRoutes,
    ...pluginsRoutes,
    ...sharedComponentsRoutes,
    ...composablesRoutes,
  ],
}
